import { Descriptions, Spin } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import EmpresaContext from '../../context/empresa-context';
import SessionContext from '../../context/session-context';
import { Vigencia } from '../personal/Descripciones';

const DescripcionesCartaVerde = ({ fields, screens }) => {
  const { empresa } = useContext(EmpresaContext);
  const [principalLoading, setPrincipalLoading] = useState();

  const { collapsed } = useContext(SessionContext);

  let marginLeft = 0;
  if (collapsed !== undefined && screens.md === true) {
    marginLeft = collapsed ? 80 / 2 : 300 / 2;
  }
  const maxWidth = 1096;

  const getDescripcionesIngreso = (ingreso) => {
    switch (ingreso) {
      case '1':
        return '1.000.000 a 5.000.000';
      case '2':
        return '5.000.000 a 10.000.000';
      case '3':
        return '10.000.000 a 15.000.000';
      case '4':
        return 'Más de 15.000.000';
      default:
        return '-';
    }
  };

  useEffect(() => {
    setPrincipalLoading(false);
  }, [fields]);

  return (
    <Spin
      spinning={principalLoading}
      delay={500}
      size="large"
      tip="Procesando la información ingresada. Aguarde un momento."
      style={{
        position: 'fixed',
        left: marginLeft,
        right: 0,
        transform: `translate(calc(50vw - 50%), calc(50vh - 50%))`
      }}
    >
      <div
        style={{
          maxWidth,
          marginTop: 'auto',
          marginBottom: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <>
          <Descriptions
            title="Datos del Vehículo"
            style={{ textAlign: 'left' }}
            bordered
            size="small"
            column={{ md: 2, sm: 1, xs: 1 }}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            <Descriptions.Item label="Marca">
              {fields.marcaDescripcion}
            </Descriptions.Item>
            <Descriptions.Item label="Modelo">
              {fields.modeloDescripcion}
            </Descriptions.Item>
            <Descriptions.Item label="Submodelo">
              {fields.submodeloDescripcion}
            </Descriptions.Item>
            <Descriptions.Item label="Año">{fields.anio}</Descriptions.Item>
            <Descriptions.Item label="Chassis">
              {fields.chassis}
            </Descriptions.Item>
            <Descriptions.Item label="Chapa">{fields.chapa}</Descriptions.Item>
          </Descriptions>

          <Descriptions
            title="Datos de Asegurado"
            style={{ textAlign: 'left', marginTop: 20 }}
            bordered
            size="small"
            column={{ md: 2, sm: 1, xs: 1 }}
          >
            <Descriptions.Item label="Nombre y Apellido" span={2}>
              {fields.nombres}
            </Descriptions.Item>
            <Descriptions.Item label="Cédula">
              {fields.cedula}
            </Descriptions.Item>

            <Descriptions.Item label="RUC">{fields.ruc}</Descriptions.Item>

            <Descriptions.Item label="Celular">
              +595{fields.celular}
            </Descriptions.Item>

            <>
              <Descriptions.Item label="Correo">
                {fields.correo}
              </Descriptions.Item>
              <Descriptions.Item label="Departamento">
                {fields.departamentoDescripcion}
              </Descriptions.Item>
              <Descriptions.Item label="Ciudad">
                {fields.distritoDescripcion}
              </Descriptions.Item>
              <Descriptions.Item label="Domicilio" span={2}>
                {fields.domicilio}
              </Descriptions.Item>
              <Descriptions.Item label="Sexo">{fields.sexo}</Descriptions.Item>
              <Descriptions.Item label="Estado civil">
                {fields.estadoCivil}
              </Descriptions.Item>
              <Descriptions.Item label="Fecha nacimiento">
                {fields.fechaNacimiento &&
                  fields.fechaNacimiento.format('DD/MM/YYYY')}
              </Descriptions.Item>

              <Descriptions.Item label="Nacionalidad">
                {fields.nacionalidad}
              </Descriptions.Item>
              <Descriptions.Item label="Lugar nacimiento">
                {fields.lugarNacimiento}
              </Descriptions.Item>
            </>
          </Descriptions>

          <Descriptions
            title="Datos de Facturación"
            style={{ textAlign: 'left', marginTop: 20 }}
            column={{ md: 2, sm: 1, xs: 1 }}
            bordered
            size="small"
          >
            <Descriptions.Item label="Razón Social" span={2}>
              {fields.tercero.nombres}
            </Descriptions.Item>
            <Descriptions.Item label="CI / RUC">
              {fields.tercero.ruc}
            </Descriptions.Item>
            <Descriptions.Item label="Correo">
              {fields.tercero.correo}
            </Descriptions.Item>

            <Descriptions.Item label="Departamento">
              {fields.departamentoTerceroDescripcion || 'N/A'}
            </Descriptions.Item>

            <Descriptions.Item label="Ciudad">
              {fields.distritoTerceroDescripcion || 'N/A'}
            </Descriptions.Item>

            <Descriptions.Item label="Dirección" span={2}>
              {fields.tercero.domicilio}
            </Descriptions.Item>
            <Descriptions.Item label="Celular">
              {fields.tercero.celular && `+595${fields.tercero.celular}`}
            </Descriptions.Item>
            <Descriptions.Item label="Teléfono (Línea Baja)">
              {fields.tercero.telefono}
            </Descriptions.Item>
          </Descriptions>

          {empresa.seprelad && (
            <>
              <br />
              <Descriptions
                title="Datos Laborales"
                style={{ textAlign: 'left', marginTop: 20 }}
                bordered
                size="small"
                column={{ md: 2, sm: 1, xs: 1 }}
              >
                <Descriptions.Item label="Profesión / Ocupación">
                  {fields.profesion}
                </Descriptions.Item>
                <Descriptions.Item label="Rango de Ingresos Mensuales Personales (Gs.)">
                  {getDescripcionesIngreso(fields.ingresos)}
                </Descriptions.Item>
                <Descriptions.Item label="¿Es Proveedor del estado?">
                  {fields.proveedorEstado ? 'Sí' : 'No'}
                </Descriptions.Item>
                <Descriptions.Item label="Tipo empleado">
                  {fields.trabajo?.toUpperCase()}
                </Descriptions.Item>
                <Descriptions.Item label="¿Es una Persona Políticamente Expuesta?">
                  {fields.politicamenteExpuesto ? 'Sí' : 'No'}
                </Descriptions.Item>
                {fields.politicamenteExpuesto && (
                  <>
                    <Descriptions.Item label="Cargo / Vínculo">
                      {fields.vinculo}
                    </Descriptions.Item>
                    <Descriptions.Item label="Entidad">
                      {fields.entidad}
                    </Descriptions.Item>
                    <Descriptions.Item label="Periodo">
                      {fields.periodo[0]?.format('DD/MM/YYYY')} -{' '}
                      {fields.periodo[1]?.format('DD/MM/YYYY')}
                    </Descriptions.Item>
                  </>
                )}
                {fields.institucion && (
                  <>
                    <Descriptions.Item label="Institución Pública">
                      {fields.institucion || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Cargo">
                      {fields.cargo}
                    </Descriptions.Item>
                    <Descriptions.Item label="Año ingreso">
                      {fields.anioIngreso}
                    </Descriptions.Item>
                  </>
                )}
                {(fields.rucEmpleador || fields.institucion) && (
                  <>
                    <Descriptions.Item label="RUC Empleador">
                      {fields.rucEmpleador || 'A Confirmar'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Empresa">
                      {fields.empresaEmpleador}
                    </Descriptions.Item>
                    <Descriptions.Item label="Teléfono">
                      {fields.telefonoEmpleador || 'A Confirmar'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Celular">
                      {fields.celularEmpleador
                        ? `+595${fields.celularEmpleador}`
                        : 'A Confirmar'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Dirección">
                      {fields.direccionEmpleador}
                    </Descriptions.Item>
                  </>
                )}
              </Descriptions>
            </>
          )}

          {fields.vigencia && (
            <Vigencia
              {...{
                vigenciaPago: fields.vigencia,
                tipo: 'vehiculo'
              }}
            />
          )}

          <Descriptions
            title="Forma de pago"
            style={{ textAlign: 'left', marginTop: 20 }}
            bordered
            size="small"
            column={{ md: 2, sm: 1, xs: 1 }}
          >
            <Descriptions.Item label="Medio de pago" span={2}>
              {fields.metodoPagoDescripcion}
            </Descriptions.Item>
          </Descriptions>
        </>
      </div>
    </Spin>
  );
};

export default DescripcionesCartaVerde;
